import React from "react";
import { ToastContainer } from "react-toastify";
import GlobalModal from "./components/shared/GlobalModal";
import ErrorToaster from "./components/shared/ErrorToaster";
import './App.css'
import './index.css';
import { PeerProvider } from "./contexts/Peer";
import UserFeedbackModal from "./components/shared/UserFeedbackModal";
import { UserProvider } from "./contexts/UserProvider";
import { TimerProvider } from "./components/TimeTracker/TimeProvider";
import { DropdownProvider } from "./contexts/DropdownContext";
import GlobalSidePanel from "./components/shared/GlobalSidePanel";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ErrorNotificationProvider } from "./contexts/ErrorNotificationContext";
import GlobalShortcuts from "./utils/GlobalShortcuts";
import { PermissionsProvider } from "./contexts/PermissionsContext";
import { GoogleDriveProvider } from "./contexts/GoogleContext";
import { MicrosoftGraphProvider } from "./contexts/MicrosoftGraphContext";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { HelmetProvider } from 'react-helmet-async';
import Auth0Routes from "./auth0-integration/Auth0Routes";
import AppShell from "./utils/AppShell";
import LicenseErrorHandler from "./components/shared/Licenses/LicenseErrorHandler";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <ErrorNotificationProvider>
          <PeerProvider>
            <GoogleDriveProvider >
              <MicrosoftGraphProvider>
                <TimerProvider>
                  <DropdownProvider>
                    <DndProvider backend={HTML5Backend}>
                      <UserProvider>
                        <PermissionsProvider>
                          <div id="portal-root"></div>
                          <UserFeedbackModal />
                          <ToastContainer position="top-right" theme="dark" autoClose={1500} />
                          <ErrorToaster />

                          <Auth0Routes>
                            <AppShell />
                          </Auth0Routes>

                          <GlobalModal />
                          <GlobalShortcuts />
                          <GlobalSidePanel />
                          <LicenseErrorHandler />

                        </PermissionsProvider>
                      </UserProvider>
                    </DndProvider>
                  </DropdownProvider>
                </TimerProvider>
              </MicrosoftGraphProvider>
            </GoogleDriveProvider>
          </PeerProvider>
        </ErrorNotificationProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;
